<div class="text-center">{{ 'common.logging-out' | translate }}</div>
